
import config from "assets/config";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { isLoginAuth, logout } from "utils/common";

export default function AuthLayout() {
  const authRef = useRef(null);
  const { pathname } = window.location;
  const history = useHistory();
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    import("hfnauth/main");
    setMounted(true);
  });
  useEffect(() => {
    localStorage.setItem("LandingPage", "/");
    if (isLoginAuth() && pathname.includes("hfnauth")) {
      history.push("/");
    }
  });
  const handleUserLoggedOut = async (event) => {
    if (event?.detail?.loggedOut) {
      await logout();
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      import("hfnauth/main").then(() => {
        authRef.current = document.querySelector("hfn-auth");

        if (authRef.current) {
          authRef.current.addEventListener(
            "userLoggedOut",
            handleUserLoggedOut
          );
        }

        return () => {
          if (authRef.current) {
            authRef.current.removeEventListener(
              "userLoggedOut",
              handleUserLoggedOut
            );
          }
        };
      });
    }
    return true;
  }, [authRef]);

  if (!mounted) {
    return null;
  }

  return (
    <hfn-auth
      ref={authRef}
      config={config?.keyCloakConfig}
      showCancel="true"
    />
  );
}